<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <LeftTab
          :complaintData="complaintData"
          @onComplaintBtnCancelClicked="onComplaintBtnCancelClicked"
          :IsAllowDelete_PersonDataDigital="false"
          :IsReadOnly_PersonDataDigital="true"
          :personals="personals"
          :attorneys="attorneys"
          @onPersonDigitalEditClicked="onPersonDigitalEditClicked"
          :IsEdit_CompanyDetail="false"
          :IsDeleteAble_CompanyDetail="false"
          :IsReadOnly_CompanyDetail="true"
          :IsEdit_CompanySearch="false"
          :complainantCompany="complainantCompany"
          @onBtnCompanySearchClicked="onBtnCompanySearchClicked"
          @onBtnCompanySearchDeleteClicked="onBtnCompanySearchDeleteClicked"
          @company-digital-modal-clicked="companyModalClicked"
          :IsReadOnly_ComplaintDetail="true"
          :complaintDetail="complaintDetail"
          :complaintCatagoryDetail="complaintCatagoryDetail"
          :complaintDetailMultiSelect="complaintDetailMultiSelect"
          :company="complaintData"
          @checkboxChanged="checkboxChanged"
          :IsEdit_TabAttachFiles="false"
          :attachFiles="attachFiles"
          :attachFileDate="attachFileDate"
          :attachFilesType2="attachFilesType2"
          :attachFileDateType2="attachFileDateType2"
          :fileFormstatusModel="fileFormstatusModel"
          :fileFormstatusModelDates="fileFormstatusModelDates"
          :fileFormstatusType3Model="fileFormstatusType3Model"
          :fileFormstatusType3ModelDates="fileFormstatusType3ModelDates"
          :fileFormstatusType4Model="fileFormstatusType4Model"
          :fileFormstatusType4ModelDates="fileFormstatusType4ModelDates"
          @onAttachFileUploaded="onAttachFileUploaded"
          @onAttachFileDelete="onAttachFileDelete"
          :IsEditData="false"
          :ComponentName="'BangkokOfficerMange'"
        />
      </b-row>
    </b-col>
    <RightTab
      ref="RightTabComponent"
      :complaintId="this.$route.query.id"
      :levelId="this.levelId"
      :redirectComponentName="'RequestConfirm'"
      :backComponentName="'BangkokOfficer'"
      :copyComponentName="'BangkokOfficerMange'"
    />

    <ModalDigitalId
      ref="modalDigitalIdComponent"
      :userId="currentUserIdModal"
      @handle-success="onModalDigitalIdSuccess"
    />

    <ModalCompany
      ref="modalCompanyComponent"
      :company="currentCompanyModal"
      @handle-submit="onBtnCompanySearchSubmit"
    />

    <ModalDigitalIdCompany
      ref="modalDigitalIdCompanyComponent"
      :compId="currentCompIdModal"
      @handle-success="onModalDigitalIdCompanySuccess"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import CompanyDetail from "../components/CompanyDetail.vue";
import CompanySearch from "../components/CompanySearch.vue";
import RightTab from "../components/RightTabAction.vue";

import TabAttachFiles from "../components/TabAttachFiles.vue";
import TabDocumentTrackingDetail from "../components/TabDocumentTrackingDetail.vue";

import ModalDigitalIdCompany from "@/views/Complaint/components/DigitalIdCompanyModal.vue";

import PersonDataDigital from "../components/PersonDataDigital.vue";
import ModalDigitalId from "../components/DigitalIdUserModal.vue";
import ModalCompany from "../components/ModalCompany.vue";
import ComplaintDetail from "../components/ComplaintDetail.vue";
import * as viewStore from "@/store/api/screening/screeningManage.js";
import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as userStore from "@/store/api/user/index.js";
import * as companyStore from "@/store/api/company/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import LeftTab from "../components/LeftTabAction.vue";
export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BCardActions,
    RightTab,
    TabAttachFiles,
    TabDocumentTrackingDetail,
    viewStore,
    complaintStore,
    ModalDigitalId,
    ModalCompany,
    PersonDataDigital,
    CompanyDetail,
    CompanySearch,
    ComplaintDetail,
    userStore,
    LeftTab,
    ModalDigitalIdCompany,
  },
  data() {
    return {
      personals: [],
      attorneys: [],
      complainantCompany: [],
      currentUserIdModal: "",
      currentCompIdModal: "",
      currentCompanyModal: {},
      complaintData: {},
      complaintDetail: [],
      complaintDetailMultiSelect: [],
      masterIdList: [],
      complainId: null,
      levelId: null,
      attachFiles: [],
      attachFileDate: [],
      attachFilesType2: [],
      attachFileDateType2: [],
      complaintCatagoryDetail: [],
      fileFormstatusModel: [],
      fileFormstatusModelDates: [],
      fileFormstatusType3Model: [],
      fileFormstatusType3ModelDates: [],
      fileFormstatusType4Model: [],
      fileFormstatusType4ModelDates: [],
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      const id = 1;
    } else {
      const qid = this.$route.query.id;
      this.getComplaintById(qid);
    }
  },
  methods: {
    rightTabComponentLoadStatus(level) {
      this.$refs.RightTabComponent.loadStatusData(level);
    },
    getComplaintById(id) {
      const _this = this;
      //console.log('userData.userId', userData.userId())
      //console.log('userData.departmentId', userData.departmentId())
      complaintStore
        .getComplaintById(id)
        .then(function(response) {
          // handle success

          console.log("GetComplaintById", response);

          _this.personals = response.data.data.personals;
          _this.attorneys = response.data.data.attorneys;
          _this.complaintData = response.data.data.complaintModel;
          _this.complainantCompany = response.data.data.complainantCompany;
          _this.attachFiles = response.data.data.attachFiles;
          _this.attachFileDate = response.data.data.attachFileDate;
          _this.attachFilesType2 = response.data.data.attachFilesType2;
          _this.attachFileDateType2 = response.data.data.attachFileDateType2;
          _this.fileFormstatusModel = response.data.data.fileFormstatusModel;
          _this.fileFormstatusModelDates =
            response.data.data.fileFormstatusModelDates;
          _this.fileFormstatusType3Model =
            response.data.data.fileFormstatusType3Model;
          _this.fileFormstatusType3ModelDates =
            response.data.data.fileFormstatusType3ModelDates;
          _this.fileFormstatusType4Model =
            response.data.data.fileFormstatusType4Model;
          _this.fileFormstatusType4ModelDates =
            response.data.data.fileFormstatusType4ModelDates;
          _this.complaintDetail = response.data.data.complaintDetail;
          _this.complaintDetailMultiSelect =
            response.data.data.complaintDetailMultiSelect;
          _this.complaintCatagoryDetail =
            response.data.data.complaintCatagoryDetail;
          _this.levelId = response.data.data.complaintModel.levelId;

          _this.rightTabComponentLoadStatus(
            response.data.data.complaintModel.levelId
          );

          console.log(
            "_this.levelId = response.data.data.complaintModel.levelId;",
            _this.levelId
          );

          _this.complaintDetail.forEach((value, index) => {
            value.tmMasterList.forEach((value2, index2) => {
              if (value2.checked === true) {
                _this.masterIdList.push(value2.masterId);
              }
            });
          });

          console.log("_this.personals", _this.personals);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onPersonDigitalEditClicked(userId) {
      this.currentUserIdModal = userId;
      this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].show();
    },
    onModalDigitalIdSuccess(id) {
      const _this = this;
      // need to get user id to update to view
      const currentUserId = id;
      this.currentUserIdModal = "";

      userStore
        .getById(currentUserId)
        .then(function(response) {
          // handle success
          console.log("userStore.getById", response);
          if (response.data.data !== null) {
            const person = response.data.data;

            const perIndex = _this.personals?.findIndex(function(value) {
              return value.userId === currentUserId;
            });

            const atIndex = _this.attorneys?.find(function(value) {
              return value.userId === currentUserId;
            });

            console.log("perIndex", perIndex, "atIndex", atIndex);

            if (perIndex >= 0 && perIndex != undefined) {
              _this.$set(_this.personals, perIndex, person);
            } else if (atIndex >= 0 && atIndex != undefined) {
              _this.$set(_this.attorneys, atIndex, person);
            } else {
              console.log(
                "personal",
                _this.personals,
                "attorneys",
                _this.attorneys
              );
              if (_this.modalMode === "personal") {
                //if (_this.personals === undefined) _this.personals = []
                _this.$set(_this.personals, _this.personals.length, person);
                //_this.personals.push(person)
              } else {
                //if (_this.attorneys === undefined) _this.attorneys = []
                _this.$set(_this.attorneys, _this.attorneys.length, person);
              }
              //console.log('personals', _this.personals, 'attorneys', _this.attorneys)
            }
          }

          //_this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].hide();
        });
    },
    companyModalClicked(id) {
      this.currentCompIdModal = id;
      this.$refs.modalDigitalIdCompanyComponent.$refs[
        "modal-digital-id-company"
      ].show();
    },
    onModalDigitalIdCompanySuccess(id) {
      let _this = this;
      console.log("this", this.complainantCompany);
      console.log("onModalDigitalIdCompanySuccess", id);
      // need to get comp id to update to view
      const currentCompId = id;
      this.currentCompIdModal = "";

      companyStore
        .getById(currentCompId)
        .then((response) => {
          const company = {
            compId: response.data.data.compId,
            companyDetail: response.data.data.juristicNameTh,
            address: {},
          };

          if (
            response.data.data.juristicBranchTh !== null &&
            response.data.data.juristicBranchTh !== undefined
          ) {
            company.companyDetail = company.companyDetail.juristicBranchTh;
          }

          console.log("company", company);

          companyStore
            .getAddressDetail(company.compId)
            .then((response2) => {
              company.address = response2.data.data;

              const compIndex = _this.complainantCompany?.findIndex(function(
                value
              ) {
                return value.compId === currentCompId;
              });

              if (compIndex >= 0 && compIndex != undefined) {
                _this.$set(_this.complainantCompany, compIndex, company);
              } else {
                _this.$set(
                  _this.complainantCompany,
                  _this.complainantCompany.length,
                  company
                );
              }
            })
            .catch((error) => {
              console.log("error", error);
            });
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdCompanyComponent.$refs[
            "modal-digital-id-company"
          ].hide();
        });
    },
    onBtnCompanySearchClicked(companyObj) {
      this.currentCompanyModal = companyObj;
      console.log("this.currentCompanyModal", this.currentCompanyModal);
      this.$refs.modalCompanyComponent.$refs["modal-company"].show();
    },
    onBtnCompanySearchDeleteClicked(companyObj) {
      console.log("onBtnCompanySearchDeleteClicked", companyObj);

      var filteredAry = this.complainantCompany.filter(
        (o) => o.compId != companyObj.compId
      );

      this.complainantCompany = filteredAry;
    },
    onBtnCompanySearchSubmit() {
      const _this = this;

      console.log("onBtnCompanySearchSubmit", this.currentCompanyModal);
      this.$refs.modalCompanyComponent.$refs["modal-company"].hide();

      const index = this.complainantCompany?.findIndex(function(value) {
        return value.compId === _this.currentCompanyModal.compId;
      });

      if (index >= 0) {
        _this.$set(_this.complainantCompany, index, _this.currentCompanyModal);
      } else {
        _this.$set(
          _this.complainantCompany,
          _this.complainantCompany.length,
          _this.currentCompanyModal
        );
      }
    },
    onComplaintBtnCancelClicked() {
      window.open(this.$router.resolve({ name: "Officer" }).href, "_self");
    },
    onComplaintBtnSubmitClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const data = {
            complaintModel: this.complaintData,
            personals: this.personals,
            attorneys: this.attorneys,
            attachFiles: this.attachFiles,
            complainantCompany: this.complainantCompany,
            userId: userData.userId(),
            complaintDetail: this.complaintDetail,
            complaintDetailMultiSelect: this.complaintDetailMultiSelect,
          };

          complaintStore
            .updateComplaint(data)
            .then((response) => {
              console.log("response", response);

              _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                variant: "success",
                solid: false,
              });

              // window.open(
              //   this.$router.resolve({ name: "Officer" }).href,
              //   "_self"
              // );
              this.$router.go(this.$router.currentRoute);
            })
            .catch((error) => {
              console.log("err", error);
            });

          //window.open(this.$router.resolve({ name: "Officer" }).href, "_self");
        }
      });
    },
    onAttachFileUploaded(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    checkboxChanged(obj) {
      //console.log("obj", obj);
      if (obj.checked) {
        this.masterIdList.push(obj.masterId);
      } else {
        //uncheck
        this.masterIdList = this.masterIdList.filter((o) => {
          return o != obj.masterId;
        });

        //remove check ที่ masterTypeIdถัดๆไปทั้งหมด เมื่อมีการ uncheck ข้อมูล

        var notInside = [];
        //get remove list
        this.complaintDetail.forEach((o) => {
          if (obj.masterTypeId < o.masterTypeId) {
            o.tmMasterList.forEach((o2) => {
              notInside.push(o2.masterId);
            });
          }
        });

        //console.log("notInside:", notInside);
        this.masterIdList = this.masterIdList.filter((o) => {
          return !notInside.includes(o);
        });
        //end check
      }

      console.log("masterIdList:", this.masterIdList);

      var self = this;

      complaintStore
        .GetMasterTypeAll(this.masterIdList)
        .then(function(response) {
          console.log("response:", response);
          var dataList = response.data.data; //list รายการทั้งหมด
          //self.$refs.Step3Ref.refreshPage()

          //แสดงรายการ checkbox
          self.complaintDetail.forEach((o) => {
            o.tmMasterList = dataList.filter((o2) => {
              return o2.masterTypeId == o.masterTypeId;
            });
          });

          //ใส่ค่า check true
          self.complaintDetail.forEach((o) => {
            o.tmMasterList.forEach((o2) => {
              if (self.masterIdList.includes(o2.masterId)) {
                o2.checked = true;
              }
            });
          });
          self.$refs.Step3Ref.refreshPage();
        })
        .catch(function(error) {
          console.log("error", error);
        })
        .then(function() {});
      //console.log("checkboxChangeRoot: ", obj);
    },
  },
};
</script>

<style lang="scss">
/* ตั้งสี primary แค่ที่เดียว */
:root {
  --primary: #00904b !important; /* <<< เปลี่ยนสีตรงนี้ครั้งเดียว */
  --primary-dark: #017b40 !important;
}

/* Override สี primary ของ Bootstrap 4 ทั้งหน้า */
/* TEXT */
.text-primary {
  color: var(--primary) !important;
}

/* BACKGROUND */
.bg-primary {
  background-color: var(--primary) !important;
}

/* BORDER */
.border-primary {
  border-color: var(--primary) !important;
}

/* BUTTON - PRIMARY */
.btn-primary {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
  background-color: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  background-color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
}

/* BUTTON - OUTLINE PRIMARY */
.btn-outline-primary {
  color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active,
.btn-outline-primary.active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
}

/* BADGE */
.badge-primary {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* ALERT */
.alert-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
  color: #fff !important;
}

/* LIST GROUP */
.list-group-item-primary {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* TABLE */
.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* PROGRESS BAR */
.progress-bar.bg-primary,
.progress-bar-primary {
  background-color: var(--primary) !important;
}

/* PAGINATION */
.page-item.active .page-link {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.page-link:hover {
  color: var(--primary) !important;
}

/* CARD */
.card.border-primary {
  border-color: var(--primary) !important;
}

.card-header.bg-primary,
.card-header.border-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
}

/* NAVBAR (text-primary, bg-primary, border-primary already cover most) */
.navbar-light .navbar-nav .nav-link.text-primary:hover {
  color: var(--primary-dark) !important;
}

.dark-layout .nav-tabs .nav-item .nav-link.active,
.dark-layout .nav-pills .nav-item .nav-link.active,
.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active {
  color: var(--primary-dark);
}

/* LINKS */
a.text-primary:hover,
a.text-primary:focus {
  color: var(--primary-dark) !important;
}

[dir="ltr"] .main-menu.menu-light .navigation > li ul .active {
  background: linear-gradient(118deg, var(--primary), rgba(0, 144, 75, 0.7));
}

[dir] .main-menu.menu-light .navigation > li ul .active {
  box-shadow: 0 0 10px 1px rgba(0, 144, 75, 0.7);
  border-radius: 4px;
}

.main-menu .navbar-header .navbar-brand .brand-text {
  color: var(--primary);
}

.dark-layout .main-menu .collapse-toggle-icon {
  color: var(--primary) !important;
}

a {
  color: var(--primary);
}

.nav-tabs .nav-link.active {
  color: var(--primary);
}

[dir="ltr"] .nav-tabs .nav-link:after {
  left: 0;
  background: linear-gradient(
    30deg,
    var(--primary),
    rgba(0, 144, 75, 0.5)
  ) !important;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: var(--primary);
}

[dir] .dropdown-item:hover,
[dir] .dropdown-item:focus {
  background-color: rgba(0, 144, 75, 0.12);
}

[dir] .dropdown-item.active,
[dir] .dropdown-item:active {
  background-color: var(--primary);
}

[dir] .btn-primary:hover:not(.disabled):not(:disabled) {
  box-shadow: 0 8px 25px -8px var(--primary);
}

.badge.badge-light-primary {
  color: var(--primary) !important;
}

.brand-logo img {
  content: url("/250px-bangkok.png");
  max-height: 62px;
}

[dir] .custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--primary);
  background-color: var(--primary);
}

[dir]
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before,
[dir]
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::before {
  box-shadow: 0 2px 4px 0 rgba(0, 144, 75, 0.4) !important;
}

[dir]
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(0, 144, 75, 0.65);
}

[dir]
  .custom-control-input:not(:disabled):active
  ~ .custom-control-label:before {
  background-color: var(--primary);
  border-color: var(--primary);
}

.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: var(--primary) !important;
}

#app [dir] .vs--open .vs__dropdown-toggle {
  border-color: var(--primary);
  border-bottom-color: var(--primary);
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}

#app [dir] .vs__dropdown-option--highlight {
  background-color: rgba(0, 144, 75, 0.12) !important;
}

#app [dir] .vs__dropdown-option--selected {
  background-color: var(--primary) !important;
}

#app [dir] .vs__dropdown-option--selected.vs__dropdown-option--highlight {
  background-color: var(--primary) !important;
}

#app .vs__dropdown-option--highlight {
  color: var(--primary) !important;
}

#app .vs__dropdown-option--selected {
  background-color: var(--primary) !important;
  color: #fff !important;
  position: relative;
}

a:hover {
  color: var(--primary-dark);
  text-decoration: none;
}

.dark-layout a:hover {
  color: var(--primary-dark);
}

[dir] .main-menu.menu-light .navigation > li.active > a {
  box-shadow: 0 0 10px 1px rgba(0, 144, 75, 0.7);
  border-radius: 4px;
}
</style>
